module.exports = __webpack_public_path__ + "static/media/empty.35b8dd48.png";